import { TimeslotInterface, TimeslotStatusEnum } from '@sport-activities/sdk';

import { Activity } from '~/core/model/activity.model';
import { FullCalendarEventInterface } from '~/organizer/shared/components/shared/calendar/interfaces/fullcalendar/event.interface';

export class FullCalendarEventAdapter {
  public static adapt(
    activity: Activity,
    timeslot: TimeslotInterface,
    color?: string
  ): FullCalendarEventInterface {
    const bookings =
      timeslot.maximumAttendeeCapacity - timeslot.remainingAttendeeCapacity;
    let title = activity.name;
    if (timeslot.status === ('PUBLISHED' as TimeslotStatusEnum)) {
      title = `${title} (${bookings}/${timeslot.maximumAttendeeCapacity})`;
    }

    return {
      color,
      end: timeslot.endDate,
      id: timeslot.identifier,
      start: timeslot.startDate,
      title,
      extendedProps: {
        visibility: activity?.visibility,
      },
    };
  }
}
